import * as monacoEditor from "monaco-editor/esm/vs/editor/editor.api";

import { getNextTranslationId } from "@components/MonacoHtmlEditor/config/insertTranslationTagHelpers";

export const insertTranslationTagClick = (editor: monacoEditor.editor.IStandaloneCodeEditor) => {
  const editorModel = editor.getModel();
  const selection = editor.getSelection();

  if (!editorModel || !selection) {
    return;
  }
  const selectedText = editorModel.getValueInRange(selection);

  // Get the current selected range
  const selectionRange = new monacoEditor.Range(
    selection.startLineNumber,
    selection.startColumn,
    selection.endLineNumber,
    selection.endColumn
  );

  // Create the edit operation to replace the selected text
  const editOperation = {
    identifier: { major: 1, minor: 1 }, // Unique identifier for the edit
    range: selectionRange,
    text: `{% translation ${getNextTranslationId(editor.getValue())} %}${selectedText}{% endtranslation %}`,
    forceMoveMarkers: true,
  };

  // Apply the edit operation to the editor
  editor.executeEdits("replaceSelectedText", [editOperation]);
};
